import { render, staticRenderFns } from "./GroupNames.vue?vue&type=template&id=dd4be72c&scoped=true"
import script from "./GroupNames.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupNames.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GroupNames.vue?vue&type=style&index=0&id=dd4be72c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4be72c",
  null
  
)

/* custom blocks */
import block0 from "./GroupNames.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports